import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getAffiliationById } from '../data/blogAffiliationList';
import '../data/affiliation-styles.css';

const OutilsPostPage = () => {
  const { id } = useParams();
  const post = getAffiliationById(id);

  if (!post) return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
          Article introuvable
        </h1>
        <Link to="/outils" style={{ color: '#3b82f6', textDecoration: 'none', fontSize: '1.125rem', fontWeight: '500' }}>
          ← Retour aux outils
        </Link>
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{post.title} | Excellence Informatique</title>
        <meta name="description" content={post.description} />
        <link rel="canonical" href={`https://mon-depannage-informatique.fr/outils/${post.category}/${post.id}`} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.description} />
        <meta property="og:image" content={post.image} />
        <meta property="og:url" content={`https://mon-depannage-informatique.fr/outils/${post.category}/${post.id}`} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={post.description} />
        <meta name="twitter:image" content={post.image} />
      </Helmet>

      <div style={{
        backgroundColor: '#ffffff',
        color: '#1f2937',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        minHeight: '100vh'
      }}>
        <div
          className="affiliation-post"
          dangerouslySetInnerHTML={{ __html: post.html }}
        />
      </div>
    </>
  );
};

export default OutilsPostPage;
